var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemCheckDashedCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2 12C2 6.477 6.477 2 12 2q.263 0 .523.013a1 1 0 1 1-.103 1.998 8 8 0 1 0 0 15.978 1 1 0 1 1 .103 1.998Q12.263 22 12 22C6.477 22 2 17.523 2 12m13.196-8.475a1 1 0 0 0 .436 1.345q.374.19.725.42a1 1 0 0 0 1.09-1.677 10 10 0 0 0-.905-.524 1 1 0 0 0-1.346.436m3.807 2.735a1 1 0 0 0-.292 1.383q.228.351.42.725a1 1 0 0 0 1.78-.91 10 10 0 0 0-.524-.906 1 1 0 0 0-1.384-.292m1.933 4.27a1 1 0 0 0-.947 1.05 8 8 0 0 1 0 .84 1 1 0 1 0 1.998.103 10 10 0 0 0 0-1.046 1 1 0 0 0-1.05-.947m-.46 4.666a1 1 0 0 0-1.346.436q-.19.374-.42.725a1 1 0 0 0 1.677 1.09q.285-.437.524-.905a1 1 0 0 0-.436-1.346m-2.736 3.807a1 1 0 0 0-1.383-.292 8 8 0 0 1-.725.42 1 1 0 1 0 .91 1.78q.467-.239.906-.524a1 1 0 0 0 .292-1.384",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M15.293 9.293 11 13.586l-2.293-2.293a.999.999 0 1 0-1.414 1.414l3 3a.997.997 0 0 0 1.414 0l5-5a.999.999 0 1 0-1.414-1.414",
  clipRule: "evenodd"
})));
export default SvgGemCheckDashedCircle;